import api from './default'

export default api('/api/school-year', 'school years')
